import type { TabBarProps, TabProps } from './TabBar.types'
import cn from 'classnames'
import * as React from 'react'
import { Tab } from './Tab'
import styles from './TabBar.module.css'

export function TabBar({
  children,
  className,
  defaultActive,
  disabled,
  onActiveChange,
  ...attributes
}: TabBarProps) {
  const [active, setActive] = React.useState(defaultActive ?? 0)

  const onClickHandler = (index: number, value?: string | number | readonly string[]) => {
    setActive(index)
    onActiveChange?.({ index, value })
  }

  return (
    <div
      className={cn(styles.wrapper, { [styles.disabled]: disabled }, className)}
      role="group"
      {...attributes}
    >
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement<TabProps>(child)) {
          const { disabled: childDisabled, name, value } = child.props
          return React.cloneElement(child, {
            active: [name, value].includes(active) || index === active,
            onClick: () => onClickHandler(index, value),
            disabled: disabled || childDisabled,
          })
        }
      })}
    </div>
  )
}

TabBar.Tab = Tab
